var $j = jQuery.noConflict();

$j(document).ready(function(){

    $j.fancybox.defaults.loop = true;
    $j.fancybox.defaults.hash = false;

    var mycontainer = "article";
    $j(mycontainer+" a[href$='.png'],"+mycontainer+" a[href$='.PNG'],"+mycontainer+" a[href$='.jpg'],"+mycontainer+" a[href$='.JPG'], "+mycontainer+" a[href$='.jpeg'],"+mycontainer+" a[href$='.JPEG'],"+mycontainer+" a[href$='.gif'],"+mycontainer+" a[href$='.GIF'], "+mycontainer+" a[href$='.bmp'],"+mycontainer+" a[href$='.BMP']").not("a[download]").attr("data-fancybox","article-fancybox").fancybox({
        protect: true
    });

    $j('.gallery').each(function(indx, element){
        $j(this).find("a[href$='.png'], a[href$='.PNG'], a[href$='.jpg'], a[href$='.JPG'], a[href$='.jpeg'], a[href$='.JPEG'], a[href$='.gif'], a[href$='.GIF'], a[href$='.bmp'], a[href$='.BMP']").attr("data-fancybox",$j(element).attr('id')).fancybox({
            protect: true
        });
    });

    $j("a.fancy").fancybox({
        protect: true
    });
	
	$j('input[type=tel]').mask("+7 (999) 999-99-99");
	
	var options = {
		animateThreshold: 10, //сколько пикселей блока д.б. видно, чтобы началась анимация
		scrollPollInterval: 10
	};
	
	$j('.foranimate').AniView(options);

	$j('input.post_title').val($j('h1').text());
	$j('input.post_url').val(window.location.href);

	if(typeof wpfront_scroll_top == "function") wpfront_scroll_top({"scroll_offset":500,"button_opacity":1,"button_fade_duration":200,"scroll_duration":400,"hide_iframe":false,"auto_hide":true,"auto_hide_after":2});

	//$j('.foranimate').each(function(indx, elem){
	//	setTimeout(function(){
	//		$j(elem).AniView(options);
	//	}, indx * 200);
	//});

	
	//$j(".foranimatehover").hover(function(){
	//	$j(this).addClass('animated ' + $j(this).data('effect'));
	//});
	//
	//$j(".foranimatehover").bind("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd",function(){
	//	$j(this).removeClass('animated ' + $j(this).data('effect'));
	//});
	
	// var gradient_target = $j('.uslugi .item .image img');
	// var gradient_target = document.getElementById('mytarget');

	// GradientMaps.applyGradientMap(gradient_target, '#0e3a73, #fff');
	
	//
	//if($j(window).width()>767){
	//	$j('#carousel_slider .carouselitem').live({
	//		mouseenter: function () {
	//			$j(this).find('.excerpt').fadeIn();
	//		},
	//		mouseleave: function () {
	//			$j(this).find('.excerpt').fadeOut();
	//		}
	//	});
	//}
	//нужно чтобы нормально работала карусель
	

	//if ( $j(window).width()>767 && $j('#carousel_slider .carouselitem').length >= 4 ){ //запускаем, если не мобильный
	//
	//	$j('.carouselitem').css('float', 'none');
	//
	//	$j('#carousel_slider_wrapper').append('<div id="portfolioprev" class="pagerlink cycle-prev"></div><div id="portfolionext" class="pagerlink cycle-next"></div>'); // так можно добавлять кнопки, когда не можем вывести их в php
	//
	//	$j('#carousel_slider')
	//	.addClass('cycle-slideshow')
	//	.attr('data-cycle-fx','carousel')
	//	.attr('data-cycle-carousel-visible','4')
	//	.attr('data-cycle-speed','300')
	//	.attr('data-cycle-timeout', '0')
	//	// .attr('data-cycle-pause-on-hover','true')
	//	.attr('data-cycle-carousel-fluid','true')
	//	.attr('data-cycle-swipe','true')
	//	.attr('data-cycle-slides','> .carouselitem')
	//	// .attr('data-cycle-pager','#bg-pager')
	//	// .attr('data-cycle-pager-template','<span></span>')
	//	.attr('data-cycle-prev','#portfolioprev')
	//	.attr('data-cycle-next','#portfolionext')
	//	.attr('data-cycle-auto-height','calc')
	//	.cycle();
	//
	//} else if ( $j(window).width()<768 && $j('#carousel_slider .carouselitem').length >= 2 ){
	//	$j('.carouselitem').css('float', 'none');
	//
	//	$j('#carousel_slider_wrapper').append('<div id="portfolioprev" class="pagerlink cycle-prev"></div><div id="portfolionext" class="pagerlink cycle-next"></div>'); // так можно добавлять кнопки, когда не можем вывести их в php
	//
	//	$j('#carousel_slider')
	//	.addClass('cycle-slideshow')
	//	.attr('data-cycle-fx','carousel')
	//	.attr('data-cycle-carousel-visible','1')
	//	.attr('data-cycle-speed','300')
	//	.attr('data-cycle-timeout', '0')
	//	// .attr('data-cycle-pause-on-hover','true')
	//	.attr('data-cycle-carousel-fluid','true')
	//	.attr('data-cycle-swipe','true')
	//	.attr('data-cycle-slides','> .carouselitem')
	//	// .attr('data-cycle-pager','#bg-pager')
	//	// .attr('data-cycle-pager-template','<span></span>')
	//	.attr('data-cycle-prev','#portfolioprev')
	//	.attr('data-cycle-next','#portfolionext')
	//	.attr('data-cycle-auto-height','calc')
	//	.cycle();
	//}

	
	if( $j(window).width()>767 && $j('#home_slider .item').length ){

		// $j('#home_slider')
		// .addClass('cycle-slideshow')
		// .attr('data-cycle-fx','fade')
		// //.attr('data-cycle-tile-count','10')
		// //.attr('data-cycle-tile-vertical','false')
		// .attr('data-cycle-speed','1000')
		// .attr('data-cycle-timeout','4000')
		// .attr('data-cycle-pager-template','<div><span></span></div>')
		// .attr('data-cycle-swipe','true')
		// .attr('data-cycle-swipe-fx','scrollHorz')
		// .attr('data-cycle-slides','> .item')
		// .cycle();

		$j('#home_slider').slick({
			dots: true,
            customPaging: function(slider, i) {
                return $j('<span></span>');
            },
			arrows: true,
			prevArrow: '<div class="slick-control slick-prev"><i class="fa fa-chevron-left" aria-hidden="true"></i></div>',
			nextArrow: '<div class="slick-control slick-next"><i class="fa fa-chevron-right" aria-hidden="true"></i></div>',
			autoplay: true,
			autoplaySpeed: 6000,
			pauseOnHover: false
		});
	}
	
	//if($j('#slider_uslugi .slideritem').length){
    //
	//	$j('#slider_uslugi')
	//	.addClass('cycle-slideshow')
	//	.attr('data-cycle-fx','fade')
	//	.attr('data-cycle-tile-count','10')
	//	.attr('data-cycle-tile-vertical','false')
	//	.attr('data-cycle-speed','1000')
	//	.attr('data-cycle-timeout','2000')
	//	.attr('data-cycle-pager-template','<div><span></span></div>')
	//	.attr('data-cycle-swipe','true')
	//	.attr('data-cycle-swipe-fx','scrollHorz')
	//	.attr('data-cycle-slides','> div.slideritem')
	//	.cycle();
	//}
	
	// if($j('#otzyvy_slider .slideritem').length){
	// 	$j('#otzyvy_slider')
	// 	.addClass('cycle-slideshow')
	// 	.attr('data-cycle-fx','scrollHorz')
	// 	.attr('data-cycle-auto-height','calc')
	// 	.attr('data-cycle-speed','500')
	// 	.attr('data-cycle-timeout','4000')
	// 	.attr('data-cycle-pause-on-hover','true')
	// 	.attr('data-cycle-swipe','true')
	// 	.attr('data-cycle-swipe-fx','scrollHorz')
	// 	.attr('data-cycle-slides','> div.slideritem')
	// 	.attr('data-cycle-prev','#otzyvy_prev')
	// 	.attr('data-cycle-next','#otzyvy_next')
	// 	.cycle();
	// }



	// if ($j(window).width()>767 && $j('aside.sidebar').outerHeight(true) < $j('article').outerHeight(true) ) { // фиксируем правую часть если не мобильный
	// 	$j('.my_affix').affix({
	// 	  offset: {
	// 	    top: function () {
	//       		return ($j('aside.sidebar').offset().top)
	// 	    },
	// 	    bottom: function () {
	// 	    	return ( $j('body').height() - $j('div.clients').offset().top );
	// 	    }
	// 	  }
	// 	})
	// }
	

	// $j(window).scroll(function() {
		
	// 	var HEADER = $j('header'),
	// 		HEADERHEIGHT = HEADER.height(),
	// 		scrolltopfunct = $j(window).scrollTop();
		
	// 	if ($j(window).scrollTop() > HEADERHEIGHT && $j(window).width() > 767) {
	// 		$j('#topnav').addClass('fixed');
	// 		HEADER.addClass('forfixed');
	// 	} else {
	// 		$j('#topnav').removeClass('fixed');	
	// 		HEADER.removeClass('forfixed');
	// 	};
		

	// });
	
	var appforms = {
		
		initialize: function(){
			this.setUpListners();
		},
	
		setUpListners: function(){
			$j('form.wpcf7-form').on('submit', appforms.submitForm);
			$j('form.wpcf7-form').on('keydown', 'input', appforms.removeError);	
		},

		submitForm: function(e){
			//e.preventDefault();
			
			var form = $j(this);		
			
			if(appforms.validateForm(form) === false) return false;			
			
		},
		
		validateForm: function(form){
			var inputs = form.find('.wpcf7-validates-as-required'),
				valid = true,
				placement = 'left';
			
			if(form.is('.form-inline')){
				placement = 'top';
			}
			
			if(form.is('.form-horizontal')){
				placement = 'right';
			}
			
			if($j(window).width() < 768){				
				placement = 'top';
			}
			
			//inputs.tooltip('destroy'); // без него тултипы не глючат
			
			$j.each(inputs, function(index, val){
				var input = $j(val),
					val = input.val(),
					formGroup = input.parents('.form-group'),
					tooltiptitle = 'Обязательно',
					error = false;
				
				if(val.length === 0){
					error = true;
				}				
				else if(input.is('.wpcf7-email')){
					var reg= /^[a-zA-Z0-9\._-]+@[-a-zA-Z0-9_\.]{2,45}$/ ;
					if (!reg.test(val)) {
						tooltiptitle = 'Ошибка ввода E-mail';
						error = true;						
					}					
				}
				
				if(error){
					formGroup.addClass('has-error').removeClass('has-success');
					input.tooltip({
						trigger: 'manual',
						placement: placement,
						title: tooltiptitle
					}).tooltip('show');
					valid = false;
				} else {					
					formGroup.addClass('has-success').removeClass('has-error');
				}
			});

			return valid;
		},
	
		removeError: function(){
			$j(this).tooltip('destroy').parents('.form-group').removeClass('has-error');
		},
	}

	appforms.initialize();

	//var app = {
		
		//initialize: function(){
		//	this.setUpListners();
		//},
	
		//setUpListners: function(){
		//	//$j('.portfolio_modal').on('show.bs.modal', app.portfolioModalShow);
		//	//$j('.portfolio_modal').on('hidden.bs.modal', app.portfolioModalHide);
		//},
	
		//portfolioModalShow: function(){
        //
		//	var gallery_items = $j(this).find('.gallery-item');
        //
		//	if( gallery_items.length ) {
        //
		//		// var portfolio_slider = $j(this).find('.portfolio_slider');
		//		var gallery = $j(this).find('.gallery');
        //
		//		// portfolio_slider.append('<div id="apartment_gallery_prev" class="cycle-control cycle-prev"></div><div id="apartment_gallery_next" class="cycle-control cycle-next"></div>');
		//		gallery.append('<div class="cycle-pager"></div><span aria-hidden="true" class="cycle-control cycle-prev"></span><span aria-hidden="true" class="cycle-control cycle-next"></span>');
		//
		//		gallery.addClass('cycle-slideshow')
		//		.attr('data-cycle-fx','fade')
		//		.attr('data-cycle-speed','500')
		//		.attr('data-cycle-timeout', '3000')
		//		.attr('data-cycle-pause-on-hover','true')
		//		.attr('data-cycle-swipe','true')
		//		.attr('data-cycle-swipe-fx','scrollHorz')
		//		.attr('data-cycle-slides','> .gallery-item')
		//		// .attr('data-cycle-pager','#bg-pager')
		//		.attr('data-cycle-pager-template','<div><span></span></div>')
		//		// .attr('data-cycle-prev','#apartment_gallery_prev')
		//		// .attr('data-cycle-next','#apartment_gallery_next')
		//		.attr('data-cycle-auto-height','calc')
		//		.cycle();
		//	}
		//},

		//portfolioModalHide: function(){
        //
		//	var gallery = $j(this).find('.cycle-slideshow');
        //
		//	if( gallery.length ) {
        //
		//		gallery.cycle('destroy');
		//		gallery.find('.cycle-control').remove();
		//		gallery.find('.cycle-pager').remove();
		//		// gallery.removeClass('cycle-slideshow');
		//	}
		//},

	//}

	//app.initialize();

	
});

// цели метрики для срабатывания при событиях jivosite
// function jivo_onOpen(state) {
//     if(typeof yaCounter41846504 != 'undefined'){
//         yaCounter41846504.reachGoal('jivosite_open');
//     }
// }
function jivo_onMessageSent(state) {
    if(typeof yaCounter41846504 != 'undefined'){
        yaCounter41846504.reachGoal('jivosite_write');
    }
}